var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboFileDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2101 2.00024H4.51013C4.23013 2.00024 4.01013 2.22024 4.01013 2.50024V21.5002C4.01013 21.7802 4.23013 22.0002 4.51013 22.0002H19.5101C19.7901 22.0002 20.0101 21.7802 20.0101 21.5002V7.80024C20.0101 7.67024 19.9601 7.54024 19.8601 7.45024L14.5701 2.15024C14.4801 2.06024 14.3501 2.00024 14.2201 2.00024H14.2101ZM16.6001 7.00024H14.0101V4.41024L16.6001 7.00024ZM18.0101 20.0002H6.01013V4.00024H12.0101V8.50024C12.0101 8.78024 12.2301 9.00024 12.5101 9.00024H18.0101V20.0002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5101 11.0002H8.51013C8.23399 11.0002 8.01013 11.2241 8.01013 11.5002V12.5002C8.01013 12.7764 8.23399 13.0002 8.51013 13.0002H15.5101C15.7863 13.0002 16.0101 12.7764 16.0101 12.5002V11.5002C16.0101 11.2241 15.7863 11.0002 15.5101 11.0002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5101 15.0002H8.51013C8.23399 15.0002 8.01013 15.2241 8.01013 15.5002V16.5002C8.01013 16.7764 8.23399 17.0002 8.51013 17.0002H12.5101C12.7863 17.0002 13.0101 16.7764 13.0101 16.5002V15.5002C13.0101 15.2241 12.7863 15.0002 12.5101 15.0002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboFileDocument);
export default __webpack_public_path__ + "static/media/FBOFileDocument.252285c3d5402d18844c9ae713b1ebde.svg";
export { ForwardRef as ReactComponent };